var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeConDarkSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.06 5.32771V5.33V7.23C10.06 8.23613 9.79557 8.92232 9.35895 9.35895C8.92232 9.79557 8.23613 10.06 7.23 10.06H5.33C4.32387 10.06 3.63768 9.79557 3.20105 9.35895C2.76443 8.92232 2.5 8.23613 2.5 7.23V5.33C2.5 4.32387 2.76441 3.63797 3.20191 3.20145C3.63959 2.76474 4.32828 2.5 5.34 2.5H7.24C8.24631 2.5 8.93213 2.76451 9.3673 3.20066C9.80228 3.63661 10.0646 4.322 10.06 5.32771Z",
    fill: "#020607",
    stroke: "#020607"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7695 2.5H18.6695C19.6756 2.5 20.3618 2.76443 20.7984 3.20105C21.235 3.63768 21.4995 4.32387 21.4995 5.33V7.23C21.4995 8.23613 21.235 8.92232 20.7984 9.35895C20.3618 9.79557 19.6756 10.06 18.6695 10.06H16.7695C15.7633 10.06 15.0771 9.79557 14.6405 9.35895C14.2039 8.92232 13.9395 8.23613 13.9395 7.23V5.33C13.9395 4.32387 14.2039 3.63768 14.6405 3.20105C15.0771 2.76443 15.7633 2.5 16.7695 2.5Z",
    fill: "#020607",
    stroke: "#020607"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7695 13.9297H18.6695C19.6756 13.9297 20.3618 14.1941 20.7984 14.6307C21.235 15.0674 21.4995 15.7536 21.4995 16.7597V18.6597C21.4995 19.6658 21.235 20.352 20.7984 20.7886C20.3618 21.2253 19.6756 21.4897 18.6695 21.4897H16.7695C15.7633 21.4897 15.0771 21.2253 14.6405 20.7886C14.2039 20.352 13.9395 19.6658 13.9395 18.6597V16.7597C13.9395 15.7536 14.2039 15.0674 14.6405 14.6307C15.0771 14.1941 15.7633 13.9297 16.7695 13.9297Z",
    fill: "#020607",
    stroke: "#020607"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.06 16.7674V16.7697V18.6697C10.06 19.6758 9.79557 20.362 9.35895 20.7986C8.92232 21.2353 8.23613 21.4997 7.23 21.4997H5.33C4.32387 21.4997 3.63797 21.2353 3.20145 20.7978C2.76474 20.3601 2.5 19.6714 2.5 18.6597V16.7597C2.5 15.7536 2.76441 15.0677 3.20191 14.6311C3.63959 14.1944 4.32828 13.9297 5.34 13.9297H7.24C8.24631 13.9297 8.93184 14.1942 9.36691 14.6312C9.80196 15.0682 10.0646 15.7561 10.06 16.7674Z",
    fill: "#020607",
    stroke: "#020607"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeConDarkSolid);
export default __webpack_public_path__ + "static/media/home-con-dark-solid.ac2454eeac680c2a912f168801d2630a.svg";
export { ForwardRef as ReactComponent };